const createCreditFrames = values => Object.freeze(values.map((value, frame) => Object.freeze({ frame, value })));

export const BOTTOM_ROW_CREDIT_FRAMES = createCreditFrames([2, 3, 4, 5, 6, 7, 8, 7, 6, 5, 4, 3]);
export const TOP_ROW_CREDIT_FRAMES = createCreditFrames([3, 4, 5, 6, 7, 8, 9, 8, 7, 6, 5, 4]);
export const SCHEDULE_ILLUSTRATION_CLASS_NAME = 'Yoga';
export const SCHEDULE_ILLUSTRATION_INSTRUCTOR_NAME = 'John Smith';
